import { render, staticRenderFns } from "./AttendanceChatNote.vue?vue&type=template&id=5d4c4dbd"
import script from "./AttendanceChatNote.vue?vue&type=script&lang=js"
export * from "./AttendanceChatNote.vue?vue&type=script&lang=js"
import style0 from "./AttendanceChatNote.vue?vue&type=style&index=0&id=5d4c4dbd&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports